import { borderRadius } from '@toggle/design-system';
import styled from 'styled-components';
import { About } from '~/modules/about/About';

export const OverviewRoot = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  max-width: 1280px;
  width: 100%;
  padding: 20px;
  margin: 0 auto;
  flex-grow: 1;
`;

export const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 20px;
`;

export const SplitSection = styled.div`
  flex: 1;
  min-width: 0;
`;

export const KnowledgeGraphWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const EventFeedWrapper = styled.div`
  flex: 1;
  min-width: 0;
  max-height: 633px;
`;

export const StyledAboutWrapper = styled.div`
  height: 100%;
  ${About.Styled.AboutRoot} {
    height: 100%;
  }
`;

export const UpgradeToUnlockWrapper = styled.div`
  border: 1px solid var(--border-soft);
  ${borderRadius.r2}
  height: 100%;
  width: 100%;
  background-color: var(--background-soft);
`;
